import React from "react";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const BillingInformationHeader = () => {
    const { t: tLang } = useTranslation();

    return (
        <React.Fragment>
            <div className="box-title-container">
                <div className="box-title-icon" aria-hidden="true">
                    <RenderIcons iconName="coins" />
                </div>
                <div className="box-title-text has-actions">
                    <h2 className="box-title">{tLang("manageAccount.myAccount.billing.title")}</h2>
                </div>
            </div>
        </React.Fragment>
    );
};

export default BillingInformationHeader;
